@if (!isLoginPage) {
  <mat-toolbar
    class="app-toolbar bg-dark-green"
    >
    @if (sidenav) {
      <mat-toolbar-row class="app-toolbar-row">
        <roots-main-menu-button
          class="toolbar-brand"
          [isOpen]="sidenav.opened"
          (click)="sidenav.toggle()"
          >
        </roots-main-menu-button>
        <app-searchbar class="app-searchbar"></app-searchbar>
        <div class="toolbar-clock" aria-label="Local time" [matTooltip]="time | date: 'fullDate'">
          <mat-icon aria-hidden="true">schedule</mat-icon>
          <span>{{ time | date: 'h:mm:ss a' }}</span>
        </div>
      </mat-toolbar-row>
    }
  </mat-toolbar>
}

<mat-sidenav-container class="sidenav-sizer" [class.no-toolbar]="isLoginPage">
  <mat-sidenav
    #sidenav="matSidenav"
    class="app-sidenav mat-elevation-z8"
    >
    <div class="sidenav-inner">
    @if (userDetails) {
      <div class="sidenav-profile">
        <div class="profile-avatar">{{ initials(userDetails.basicName) }}</div>
        <div class="profile-text">
          <div class="profile-name" [matTooltip]="userDetails.basicName" matTooltipPosition="right">{{ userDetails.basicName }}</div>
          @if (userType) {
            <span class="profile-role">{{ roleLabel(userType) }}</span>
          }
        </div>
      </div>
    } @else {
      <div class="sidenav-profile profile-missing">
        <div class="profile-avatar"><mat-icon>link_off</mat-icon></div>
        <div class="profile-text">
          <div class="profile-name">Profile not loaded</div>
          <div class="profile-hint">Your session may have expired.</div>
          <div class="profile-actions">
            <button type="button" (click)="refresh()" matTooltip="Reload your Roots profile">Refresh</button>
            <button type="button" (click)="logout()" matTooltip="Logout from Roots">Logout</button>
          </div>
        </div>
      </div>
    }
    <div class="sidenav-section-label">Menu</div>
    @if (navItems) {
      <nav class="sidenav-nav">
        @for (item of navItems; track item) {
          <app-menu-list-item [item]="item" (selectedTabChange)="tabChanged($event)">
          </app-menu-list-item>
        }
          <!-- <div class="support-ticket-section"> -->
          <!-- <h4 class="jira-ticket-title">Support Ticket Creation</h4>
          <hr style="margin: 0px; background-color: lightgrey;" />
          <a
            mat-list-item
            id="feedback_button"
            class="mid"
            matTooltip="Provide feedback regarding any of the apps or environments"
            matTooltipPosition="below"
            >
            <i class="material-icons"> question_answer </i>
            Give Feedback
          </a>
          <a
            mat-list-item
            id="bug_button"
            class="mid"
            matTooltip="Create a Bug ticket to identify and fix the problem"
            matTooltipPosition="below"
            >
            <i class="material-icons"> bug_report </i>
            Report Bug
          </a>
        </div>
        <hr style="margin: 0px; background-color: lightgrey;" />
        <a
          mat-list-item
          class="mid"
          (click)="checkServer()"
          matTooltip="Provide feedback regarding any of the apps or environments"
          matTooltipPosition="below"
          >
          <i class="material-icons"> question_answer </i>
          Server Status
        </a> -->
      </nav>
    }
    <div class="sidenav-footer">
      <a class="sidenav-logout" (click)="logout()" matTooltip="Logout from Roots" matTooltipPosition="right">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </a>
      <div class="sidenav-version">Roots v{{ version }}</div>
    </div>
    </div>
</mat-sidenav>

<!--Main content goes here-->
<mat-sidenav-content>
  <router-outlet></router-outlet>
</mat-sidenav-content>
</mat-sidenav-container>
